module.exports = __webpack_public_path__ + "img/members-right-ck1.43d83dc1.png";